<div class="relative flex w-full items-center justify-center">
  <canvas #gaugeChart class="h-full w-full"></canvas>
</div>
